import { PropsWithChildren, Suspense, useEffect, useState } from "react";

import { useUserContext } from "@/components/user-context";
import { useMlBasedXflowRecommendedProduct } from "@/components/user-context/helpers/xflow-ml-recommendation";
import { useGupsStatus } from "@/templates/ondemand/signup/confirmation/confirmation-page/src/hooks/use-gups";
import { experiments, useExperiment } from "@/utils/experiment";

import { HeroCTASkeleton } from "./hero-cta-skeleton";

export const LoggedInHeroContainer = ({ children }: PropsWithChildren) => {
    const {
        profile: { requestInProgress: profileRequestInProgress },
        user: { requestInProgress: userRequestInProgress }
    } = useUserContext();

    const { requestInProgress: mlRecommendationRequestInProgress } =
        useMlBasedXflowRecommendedProduct();
    const xflowRecommendationExperiment = useExperiment(
        experiments.gwp10965XflowRecommendation2NbpDriven
    );
    const gwp10965XflowRecommendation =
        xflowRecommendationExperiment.type === "enrolled" &&
        xflowRecommendationExperiment.value === true;

    const [userProfileInProgress, setUserProfileInProgress] = useState(true);

    const { getUserProfileJobFunctionCallback } = useGupsStatus();

    useEffect(() => {
        getUserProfileJobFunctionCallback("homepage-xflow-job-function").then(
            (response) => {
                setUserProfileInProgress(response?.requestInProgress);
            }
        );
    }, [getUserProfileJobFunctionCallback]);

    const isBrowser = typeof window !== "undefined";
    if (!isBrowser) {
        return <HeroCTASkeleton />;
    }

    // Checking for both user and profile request in progress,
    // since profileRequestInProgress is initially defined as 'false' and then gets updated to true when the request is made.
    if (
        userRequestInProgress ||
        profileRequestInProgress ||
        userProfileInProgress ||
        (mlRecommendationRequestInProgress && gwp10965XflowRecommendation)
    ) {
        return <HeroCTASkeleton />;
    }

    return <Suspense fallback={<HeroCTASkeleton />}>{children}</Suspense>;
};

LoggedInHeroContainer.displayName = "LoggedInHeroContainer";
